<template>
  <div class="comment-box">
    <template v-if="success">
      <strong>{{ i18n.t('petitions.comments.comment_thank_you.thank_you') }}</strong>
    </template>
    <template v-else>
      {{ i18n.t('petitions.comments.form.reason_to_sign') }}
      <text-input input-name="comment_text" multiline :value="text" :validation-errors="validationErrors" class="mb-3"
                  @changed="updateText" />
      <submit-button :form-valid="text.length > 0" :submit-in-progress="submitting" @click="submitComment" />
    </template>
  </div>
</template>

<script>
import SubmitButton from '@/components/buttons/submit-button.vue'
import TextInput from '@/components/inputs/text-input.vue'
import ajax from '../../helpers/ajax'
import { mapMutations } from 'vuex'
import { nextTick } from 'vue'

export default {
  components: { SubmitButton, TextInput },

  props: {
    createPetitionCommentPath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      success: false,
      submitting: false,
      text: '',
      validationErrors: []
    }
  },

  methods: {
    ...mapMutations('comments', ['addCreatedComment']),
    updateText(text) {
      this.text = text
    },

    submitComment() {
      this.submitting = true

      ajax.post({
        url: this.createPetitionCommentPath,
        data: {
          comment: {
            text: this.text
          }
        },
        successHandler: ({ data }) => {
          nextTick(() => {
            this.success = true
          })
          this.addCreatedComment(data.comment)
        },
        errorHandler: ({ info }) => {
          this.validationErrors = info.errors
        }
      }).then(() => {
        this.submitting = false
      })
    }
  }
}
</script>
